var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.loading)?_c('PageLoading'):_vm._e(),(_vm.klarnaIframeSrc)?_c('iframe',{staticClass:"payment__iframe",attrs:{"id":"dibs-iframe","src":_vm.klarnaIframeSrc,"frameborder":"0"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }